import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

import store from "@/store";
import { validateSessionActivity } from "@/utils/sessionTimeout";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  if (store.state.auth && to.name !== "login") {
    const expired = validateSessionActivity();

    if (expired) {
      store.dispatch("logoutAction");
      return next({ name: "login" });
    }
  }

  const middleware = to.meta.middleware;

  return middleware ? middleware(next) : next();
});

export default router;
